import * as THREE from 'three'
import site from '../../../content/site.js'
import { lineTexture } from '../../Utils/localizedTexture.js'
import { t } from '../../../content/i18n.js'

/**
 * AI BASED CREATIVE enstalasyonu: 27 pastel küpten karışık bir Rubik küpü (tools/blender/toys.py → cubelet)
 * + önünde devrilebilen başlık satırları (site.js → installation.title) + SIFIRLA alanı.
 * Küpler toy malzemesiyle, katlar tam temasla dizilir (piramitteki kural); başta uykudadır, araba dokununca dağılır.
 */
const COLORS = ['mint', 'lilac', 'blush', 'pistachio', 'ice', 'lavender']
const SIZE = 0.8
const GAP = 0.02

export default class InstallationSection
{
    constructor(_options)
    {
        // Options
        this.resources = _options.resources
        this.objects = _options.objects
        this.materials = _options.materials
        this.areas = _options.areas
        this.blockText = _options.blockText
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setCube()
        this.setTitle()
        this.setReset()
    }

    setCube()
    {
        const step = SIZE + GAP
        this.cubes = []

        for(let level = 0; level < 3; level++)
        {
            for(let row = 0; row < 3; row++)
            {
                for(let column = 0; column < 3; column++)
                {
                    // Karışık küp: yüz komşuları hiç aynı renk değil, her renkten 4–5 parça, görünen her yüzde 6 renk
                    const color = COLORS[(column + row + level * 2 + column * row * 3) % COLORS.length]
                    this.cubes.push(this.objects.add({
                        base: this.resources.items.toysCubeletBase.scene,
                        collision: this.resources.items.toysCubeletCollision.scene,
                        offset: new THREE.Vector3(this.x + (column - 1) * step, this.y + (row - 1) * step, level * SIZE + 0.001),
                        rotation: new THREE.Euler(0, 0, 0),
                        duplicated: true,
                        material: this.materials.items[color],
                        shadow: { sizeX: 1.3, sizeY: 1.3, offsetZ: - 0.3, alpha: 0.3 },
                        mass: 0.5,
                        physicsMaterial: 'toy',
                        sleepSpeedLimit: 0.25, // yığın uyanınca yürümesin (ölçüm: 8 sn'de 137 mm → 9 mm)
                        soundName: 'block'
                    }))
                }
            }
        }
    }

    setTitle()
    {
        // Küpün önünde (kameraya yakın) satırlar; 0.8 m harfler arası 2.6 m (TaigaSection ile aynı pay)
        this.title = site.installation.title.flatMap((_line, _index) => this.blockText.add(_line, {
            x: this.x,
            y: this.y - 3 - _index * 2.6,
            align: 'center',
            material: this.materials.items.accent
        }).items)
    }

    setReset()
    {
        this.resetArea = this.areas.add({
            position: new THREE.Vector2(this.x + 4.6, this.y - 0.4),
            halfExtents: new THREE.Vector2(1.3, 1.3)
        })
        this.resetArea.on('interact', () =>
        {
            this.reset()
        })

        this.resetTexture = lineTexture(() => t('floorReset'))
        const label = new THREE.Mesh(
            new THREE.PlaneGeometry(3.4, 0.85),
            new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resetTexture })
        )
        label.position.set(this.x + 4.6, this.y - 2.3, 0.002)
        label.matrixAutoUpdate = false
        label.updateMatrix()
        this.container.add(label)
    }

    reset()
    {
        for(const _item of [...this.cubes, ...this.title])
        {
            _item.collision.reset()
            _item.collision.body.velocity.set(0, 0, 0)
            _item.collision.body.angularVelocity.set(0, 0, 0)
        }
    }
}
